import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { DocumentsTreeComponent } from './documents-tree.component';
import { DocumentsTreeNodeComponent } from '../documents-tree-node/documents-tree-node.component';

@NgModule({
  declarations: [DocumentsTreeComponent, DocumentsTreeNodeComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot()
  ],
  exports: [DocumentsTreeComponent],
  entryComponents: [DocumentsTreeComponent]
})
export class DocumentsTreeModule { }
